var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9994 0C14.3541 0 0 14.3552 0 32C0 49.6448 14.3541 64 31.9994 64C49.6446 64 64 49.6448 64 32C64 14.3552 49.6446 0 31.9994 0ZM31.9994 59.8032C16.6688 59.8032 4.1968 47.3306 4.1968 32C4.1968 16.6693 16.6686 4.19696 31.9994 4.19696C47.3301 4.19696 59.8027 16.6694 59.8027 32C59.8029 47.3306 47.3299 59.8032 31.9994 59.8032Z",
    fill: "#63A5A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.585 21.5236L27.084 38.0237L20.4137 31.3549C19.5941 30.5362 18.2662 30.5357 17.4465 31.3554C16.6265 32.1754 16.6265 33.5034 17.4465 34.3231L25.6006 42.4759C26.0104 42.8852 26.5472 43.09 27.084 43.09C27.6208 43.09 28.159 42.8852 28.5686 42.4753C28.5699 42.4735 28.5709 42.4717 28.573 42.4697L46.552 24.4908C47.372 23.6716 47.372 22.3426 46.552 21.5234C45.7325 20.7037 44.4037 20.7037 43.585 21.5236Z",
    fill: "#63A5A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.e67dbe75.svg";
export { ForwardRef as ReactComponent };